import React, { useEffect, useState } from "react";
import { Container, Paper, Button, Grid, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const HistoryForm = () => {
  const [ setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const mockData = [
    {
      id: 1,
      fecha: "2025-04-10",
      idSiniestro: "SN-001",
      usuario: "juan.perez@example.com",
      email: "juan.perez@example.com",
    },
    {
      id: 2,
      fecha: "2025-04-11",
      idSiniestro: "SN-002",
      usuario: "maria.lopez@example.com",
      email: "maria.lopez@example.com",
    },
    {
      id: 3,
      fecha: "2025-04-12",
      idSiniestro: "SN-003",
      usuario: "carlos.gomez@example.com",
      email: "carlos.gomez@example.com",
    },
    {
      id: 4,
      fecha: "2025-04-13",
      idSiniestro: "SN-004",
      usuario: "laura.martinez@example.com",
      email: "laura.martinez@example.com",
    },
    {
      id: 5,
      fecha: "2025-04-14",
      idSiniestro: "SN-005",
      usuario: "andres.ruiz@example.com",
      email: "andres.ruiz@example.com",
    },
  ];
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await axios.get("http://localhost:4000/formularios");
        // const response = await axios.get("https://siniestros-backend-vmly.onrender.com/formularios");
        const response = await axios.get("https://siniestros-backend-app.onrender.com/formularios");
        setData(response.data);
      } catch (error) {
        console.error("Error al obtener los datos", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  },[setData]);

  return (
    <Container maxWidth="md" sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", fontFamily: "'Inter', sans-serif" }}>
      <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
        <Typography variant="h5" align="center" sx={{ mb: 3 }}>
          Historial de formularios (Ejemplo)
        </Typography>

        {isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Fecha</strong></TableCell>
                  <TableCell><strong>ID Siniestro</strong></TableCell>
                  <TableCell><strong>Usuario</strong></TableCell>
                  <TableCell><strong>Afectado</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mockData.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{row.fecha}</TableCell>
                    <TableCell>{row.idSiniestro}</TableCell>
                    <TableCell>{row.usuario.split("@")[0]}</TableCell>
                    <TableCell>{row.email}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Grid container spacing={2} sx={{ mt: 3 }}>
          <Grid item xs={12}>
            <Button variant="outlined" color="primary" fullWidth onClick={() => navigate(-1)}>
              Volver Atrás
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default HistoryForm;
